export const SEARCH_TYPE = "searchType";
export const SEARCH_CRITERIA = "searchCriteria";

export const searchType = [
  {
    label: "CLearing Doc ID",
    value: "postDocumentHeaderId",
    operator: "EQUAL",
  },
  { label: "Billed Amount", value: "amount", operator: "EQUAL" },
  { label: "Clearing Amount", value: "clearingAmount", operator: "EQUAL" },
  { label: "Cleared By", value: "createdByName", operator: "CONTAINS" },
];
